import { ReactNode } from "react"
import { css } from "@emotion/css"

import { ReactComponent as Logo } from "assets/logos/logo-group.svg"

const styles = {
  shell: css`
    display: flex;
    overflow: hidden;
  `,
  content: css`
    width: 50%;
    height: 100vh;
    padding: var(--spacing-xxl-2);
    background-color: var(--white);
  `,
  logo: css`
    width: 50%;
    height: 100vh;
    background-color: var(--primary-main);
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    position: relative;
  `,
  icon: css`
    position: absolute;
    bottom: -178px;
  `,
}

export type LayoutProps = {
  children: ReactNode
}
export function Layout(props: LayoutProps) {
  return (
    <div className={styles.shell}>
      <div className={styles.content}>{props.children}</div>
      <div className={styles.logo}>
        <div className={styles.icon}>
          <Logo />
        </div>
      </div>
    </div>
  )
}
